import { apiB2B } from '../axios-client';
import { B2B_PROALLOWANCE_V2_PATH } from '../../constants/links';
export var proAllowanceApi = {
    getActiveAllowance: function (userId) {
        return apiB2B.get("".concat(B2B_PROALLOWANCE_V2_PATH, "/").concat(userId, "/getActiveRunnerAllowance"));
    },
    disableAllowance: function (allowanceId) {
        return apiB2B.put(B2B_PROALLOWANCE_V2_PATH, {
            RunnerAllowanceRequest: {
                allowanceId: allowanceId,
            },
        });
    },
};
